import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink,
  UserCredential,
} from 'firebase/auth'
import { useState } from 'react'

export type LoginState = 'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED'

export function useSignInWithLink(): [
  LoginState,
  (email: string | null) => Promise<UserCredential | undefined>,
] {
  const [loginState, setLoginState] = useState<LoginState>('NOT_STARTED')

  const signInWithLink = async (email: string | null) => {
    setLoginState('IN_PROGRESS')
    const auth = getAuth()
    if (isSignInWithEmailLink(auth, window.location.href)) {
      if (!email) {
        console.error('No email found')
        setLoginState('FAILED')
        return
      }

      let userDetails

      try {
        userDetails = await signInWithEmailLink(
          auth,
          email,
          window.location.href
        )
      } catch (error) {
        if (
          error &&
          typeof error === 'object' &&
          'code' in error &&
          error.code === 'auth/email-already-in-use'
        ) {
          // Handle the case where email is already in use
          //Email already in use, do nothing
        } else {
          // Handle errors
          setLoginState('FAILED')
          console.error('Sign in error:', error)
        }
      }

      if (!userDetails) {
        console.error('No user details found')
        setLoginState('FAILED')
        return
      }
      return userDetails
    }
  }

  return [loginState, signInWithLink]
}
